<nz-card>
    <div class="product-container">
        <div class="product-image__container">
            <img [src]="imageUrl" alt="Product Image">
        </div>

        <div class="product-info__container">
            <div class="product-info__name">{{ product.name }}</div>
            <div class="product-info__seller" *ngIf="product.seller?.displayName">by: {{ product.seller.displayName }}</div>
            <div class="product-info__description">
                {{ product.shortDescription | ellipsis:['180'] }}
            </div>
            <div class="product-info__suffix">
                <div class="product-info__suffix-item" *ngIf="language">
                    <ng-container *ngTemplateOutlet="languageSVG"></ng-container>
                    <span>{{ language }}</span>
                </div>

                <div class="product-info__suffix-item" *ngIf="deliveryFormat">
                    <ng-container *ngTemplateOutlet="deliveryFormatSVG"></ng-container>
                    <span>{{ deliveryFormat }}</span>
                </div>

                <div class="product-info__suffix-item" *ngIf="certificateType">
                    <ng-container *ngTemplateOutlet="certificateTypeSVG"></ng-container>
                    <span>{{ certificateType }}</span>
                </div>
            </div>
        </div>

        <div class="product-suffix__container">
            <span class="product-suffix__price">{{ currencySign || product.pricing.currency }}  {{ product.pricing.amount }}</span>
            <a [routerLink]="['/products/details', product.sku]">View</a>
        </div>
    </div>
</nz-card>

<ng-template #languageSVG>
    <svg
            version="1.2"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            overflow="visible"
            preserveAspectRatio="none"
            viewBox="0 0 514 514"
            width="16"
            height="16"
    >
        <g transform="translate(1, 1)">
            <path
                    d="M128 216c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 384c-28.3 0-56.3-4.3-83.2-12.8l-15.2-4.8-13 9.2c-23 16.3-58.5 35.3-102.6 39.6 12-15.1 29.8-40.4 40.8-69.6l7.1-18.7-13.7-14.6C47.3 313.7 32 277.6 32 240c0-97 100.5-176 224-176s224 79 224 176-100.5 176-224 176z"
                    vector-effect="non-scaling-stroke"
                    style="fill: rgb(142, 143, 166);"
            />
        </g>
    </svg>
</ng-template>

<ng-template #deliveryFormatSVG>
    <svg
            version="1.2"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            overflow="visible"
            preserveAspectRatio="none"
            viewBox="0 0 514 514"
            width="16"
            height="16"
    >
        <g transform="translate(1, 1)">
            <path
                    d="M497.9 97.98L414.02 14.1c-9-9-21.19-14.1-33.89-14.1H176c-26.5.1-47.99 21.6-47.99 48.09V165.7c-5.97 0-11.94-1.68-24.13-5.03-1.7-.46-3.36-.66-4.96-.66-5.56 0-10.43 2.5-13.66 5.79-17.95 18.26-17.07 17.77-41.7 24.5-6.7 1.81-11.97 7.21-13.78 14.07-6.47 24.67-6.09 24.16-24.02 42.32-4.95 5.04-6.9 12.48-5.08 19.43 6.56 24.38 6.52 24.39 0 48.76-1.82 6.95.12 14.4 5.08 19.45 18 18.15 17.58 17.79 24.02 42.29 1.8 6.88 7.08 12.27 13.78 14.1 1.8.48 2.92.8 4.46 1.21V496c0 5.55 2.87 10.69 7.59 13.61 4.66 2.91 10.59 3.16 15.56.7l56.84-28.42 56.84 28.42c2.25 1.12 4.72 1.69 7.16 1.69h272c26.49 0 47.99-21.5 47.99-47.99V131.97c0-12.69-5.1-24.99-14.1-33.99zM384.03 32.59c2.8.7 5.3 2.1 7.4 4.2l83.88 83.88c2.1 2.1 3.5 4.6 4.2 7.4h-95.48V32.59zM33.28 316.68c5.7-22.3 5.7-30.23.01-52.39 15.65-16.2 19.56-22.98 25.63-45.06 21.57-6.13 28.06-9.92 43.88-25.69 9.8 2.62 16.82 4.15 25.21 4.15 8.28 0 15.25-1.49 25.19-4.16 15.56 15.51 22.49 19.58 43.86 25.68 5.98 21.95 9.71 28.63 25.65 45.07-5.77 22.45-5.76 30 0 52.4-15.62 16.17-19.55 22.96-25.61 44.96-14.63 3.92-24 7.36-37.25 19.36-9.94-4.53-20.78-6.89-31.85-6.89s-21.9 2.36-31.85 6.9c-13.18-11.88-22.56-15.34-37.23-19.33-5.97-21.89-9.72-28.57-25.64-45zm101.89 133.01c-4.5-2.25-9.81-2.25-14.31 0l-40.84 20.42V409.9c.12.12.19.17.31.29 3.75 3.82 8.68 5.79 13.64 5.79 3.5 0 7.02-.98 10.16-2.97 7.25-4.59 15.56-6.88 23.87-6.88s16.62 2.29 23.87 6.86c3.16 2.02 6.68 3.01 10.17 3.01 4.96 0 9.87-1.99 13.63-5.79.13-.13.21-.18.34-.32v60.22l-40.84-20.42zm344.84 14.32c0 8.8-7.2 16-16 16h-256V391.9c1.54-.4 2.65-.71 4.44-1.19 6.7-1.82 11.97-7.22 13.77-14.08 6.47-24.68 6.09-24.16 24.03-42.32 4.95-5.04 6.9-12.49 5.07-19.44-6.53-24.33-6.55-24.34 0-48.76 1.83-6.95-.12-14.4-5.07-19.45-18-18.15-17.58-17.79-24.03-42.29-1.8-6.87-7.07-12.27-13.75-14.09-24.23-6.57-23.89-6.23-41.72-24.52-2.94-2.97-6.78-4.52-10.74-5.16V48.09c0-8.8 7.2-16.09 16-16.09h176.03v104.07c0 13.3 10.7 23.93 24 23.93h103.98v304.01z"
                    vector-effect="non-scaling-stroke"
                    style="fill: rgb(142, 143, 166);"
            />
        </g>
    </svg>
</ng-template>

<ng-template #certificateTypeSVG>
    <svg
            version="1.2"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            overflow="visible"
            preserveAspectRatio="none"
            viewBox="0 0 499.8999938964844 514"
            xml:space="preserve"
            y="0px"
            x="0px"
            id="Layer_1_1554977240245"
            width="16"
            height="16"
    >
      <g transform="translate(1, 1)">
        <path
                d="M143.8,223.8h166.5c2,0,3.7-1.7,3.7-3.7v-14.8c0-2-1.7-3.7-3.7-3.7H143.8c-2,0-3.7,1.7-3.7,3.7v14.8  C140.1,222.1,141.7,223.8,143.8,223.8z"
                vector-effect="non-scaling-stroke"
                style="fill: rgb(142, 143, 166);"
        />
          <path
                  d="M143.8,311.4H228l14-14v-4.5c0-2-1.7-3.7-3.7-3.7h-94.5c-2,0-3.7,1.7-3.7,3.7v14.8C140.1,309.7,141.7,311.4,143.8,311.4z"
                  vector-effect="non-scaling-stroke"
                  style="fill: rgb(142, 143, 166);"
          />
          <path
                  d="M105.5,190.4H75.9c-4.1,0-7.4,3.3-7.4,7.4v29.6c0,4.1,3.3,7.4,7.4,7.4h29.6c4.1,0,7.4-3.3,7.4-7.4v-29.6  C112.9,193.8,109.6,190.4,105.5,190.4z"
                  vector-effect="non-scaling-stroke"
                  style="fill: rgb(142, 143, 166);"
          />
          <path
                  d="M141.3,136.1h54.5c0.7,0,1.2-1.7,1.2-3.7v-14.8c0-2-0.5-3.7-1.2-3.7h-54.5c-0.7,0-1.2,1.7-1.2,3.7v14.8  C140.1,134.5,140.6,136.1,141.3,136.1z"
                  vector-effect="non-scaling-stroke"
                  style="fill: rgb(142, 143, 166);"
          />
          <path
                  d="M105.5,102.8H75.9c-4.1,0-7.4,3.3-7.4,7.4v29.6c0,4.1,3.3,7.4,7.4,7.4h29.6c4.1,0,7.4-3.3,7.4-7.4v-29.6  C112.9,106.1,109.6,102.8,105.5,102.8z"
                  vector-effect="non-scaling-stroke"
                  style="fill: rgb(142, 143, 166);"
          />
          <path
                  d="M105.5,365.7H75.9c-4.1,0-7.4,3.3-7.4,7.4v29.6c0,4.1,3.3,7.4,7.4,7.4h29.6c4.1,0,7.4-3.3,7.4-7.4v-29.6  C112.9,369,109.6,365.7,105.5,365.7z"
                  vector-effect="non-scaling-stroke"
                  style="fill: rgb(142, 143, 166);"
          />
          <path
                  d="M183.5,376.8h-39.7c-2,0-3.7,1.7-3.7,3.7v14.8c0,2,1.7,3.7,3.7,3.7h36.5L183.5,376.8z"
                  vector-effect="non-scaling-stroke"
                  style="fill: rgb(142, 143, 166);"
          />
          <path
                  d="M105.5,278.1H75.9c-4.1,0-7.4,3.3-7.4,7.4v29.6c0,4.1,3.3,7.4,7.4,7.4h29.6c4.1,0,7.4-3.3,7.4-7.4v-29.6  C112.9,281.4,109.6,278.1,105.5,278.1z"
                  vector-effect="non-scaling-stroke"
                  style="fill: rgb(142, 143, 166);"
          />
          <path
                  d="M352,361.9V464c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V48c0-8.8,7.2-16,16-16h176v104c0,13.3,10.7,24,24,24h104v74.9  l32-32v-71c0-12.7-5.1-25-14.1-34L286,14c-9-9-21.2-14.1-33.9-14.1H48C21.5,0,0,21.5,0,48v416c0,26.5,21.5,48,48,48h288  c26.5,0,48-21.5,48-48V329.9L352,361.9z M256,32.5c2.8,0.7,5.3,2.1,7.4,4.2l83.9,83.9c2.1,2.1,3.5,4.6,4.2,7.4H256V32.5z"
                  vector-effect="non-scaling-stroke"
                  style="fill: rgb(142, 143, 166);"
          />
          <path
                  d="M490.7,195l-35.3-35.3c-5.6-5.6-13.1-8.7-21-8.7c-7.9,0-15.3,3.1-21,8.7l-210,209.9l-0.4,0.4l-7.6,67.6  c-0.5,4.5,1,8.9,3.9,12.2c2.9,3.3,7.2,5.2,11.6,5.2c0.4,0,0.7,0,1-0.1c0.2,0,0.4,0,0.6,0l67.3-7.5l0.5-0.1l210.3-210.3  C502.2,225.5,502.2,206.6,490.7,195z M424.7,268.5L269.2,424l-48,5.3l5.3-48L382,225.8L424.7,268.5z M473.3,219.7l-31.4,31.4  l-42.7-42.7l31.4-31.4c1-1,2.3-1.6,3.6-1.6c1.4,0,2.8,0.6,3.7,1.6l35.3,35.3C475.3,214.4,475.3,217.7,473.3,219.7z"
                  vector-effect="non-scaling-stroke"
                  style="fill: rgb(142, 143, 166);"
          />
      </g>
    </svg>
</ng-template>
